import {useEffect} from 'react'

import {dispatch, useSelector} from '../../store.js'
import {SETTINGS_PAGE} from '../../common/constants/Pages.js'
import {setCurrentPage} from '../../redux/actions/ui/index.js'
import {SETTINGS} from '../../common/constants/SettingsPanels.js'
import {locationSelector} from '../../redux/selectors/ui/location.js'

export default function SettingsLocationListener() {
  const {
    pathComponents: [resource],
  } = useSelector(locationSelector)
  const isThisPage = resource === SETTINGS

  useEffect(() => {
    if (!isThisPage) {
      return
    }

    dispatch(setCurrentPage(SETTINGS_PAGE))
  }, [isThisPage])

  return null
}
